import { InvitationApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const invitationApi = new InvitationApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
